import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";
import { createRequestState, requestFailed, requestStarted, requestSucceeded } from "./requestState";

const slice = createSlice({
    name: "subcontractors",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        filterList: [],
        filterList2: [],
        subByIdList: [],
        performers: [],
        reminder: "",
        addNewId: 0,
        addedUser: null,
        validateDuplicateData: false,
        checkSubEmail: null,
        checkSubUsrEmail: null,
        checkSubUsrMobile: null,
        subcontractorfilter: "",
        currentWfTask: null,
        mailSentStatus: null,
        requests: {
            list: createRequestState(),
            filter: createRequestState(),
            filter2: createRequestState(),
            byId: createRequestState(),
            performers: createRequestState(),
            checkEmail: createRequestState(),
            checkUserEmail: createRequestState(),
            checkUserMobile: createRequestState(),
        }
    },
    reducers: {
        subcontractorRequestStarted: (subcontractors, action) => {
            requestStarted(subcontractors.requests, action.payload);
            subcontractors.loading = true;
        },
        subcontractorRequestFailed: (subcontractors, action) => {
            requestFailed(subcontractors.requests, action.payload?.key, action.payload?.error || action.payload);
            subcontractors.loading = false;
        },
        subcontractorAdded: (subcontractors, action) => {
            subcontractors.addNewId = action.payload;
            subcontractors.checkSubEmail = null;
            subcontractors.checkSubUsrEmail = null;
            subcontractors.checkSubUsrMobile = null;
        },
        subcontractorUserRefresh: (subcontractors, action) => {
            subcontractors.checkSubEmail = null;
            subcontractors.checkSubUsrEmail = null;
            subcontractors.checkSubUsrMobile = null;
        },
        subcontractorUserAdded: (subcontractors, action) => {
            subcontractors.addedUser = action.payload;
            subcontractors.checkSubEmail = null;
            subcontractors.checkSubUsrEmail = null;
            subcontractors.checkSubUsrMobile = null;
        },
        subcontractorUserStatus: (subcontractors) => {
            subcontractors.addedUser = null;
        },
        subcontractorUserid: (subcontractors) => {
            subcontractors.addNewId = 0;
        },
        subcontractorsReceived: (subcontractors, action) => {
            subcontractors.list = action.payload;
            subcontractors.reminder = "";
            subcontractors.loading = false;
            subcontractors.addedUser = null;
            subcontractors.addNewId = 0;
            requestSucceeded(subcontractors.requests, "list");
        },
        filterSubcontractorsReceived: (subcontractors, action) => {
            subcontractors.filterList = action.payload;
            subcontractors.reminder = "";
            subcontractors.loading = false;
            subcontractors.addedUser = null;
            subcontractors.addNewId = 0;
            requestSucceeded(subcontractors.requests, "filter");
        },
        filterSubcontractorsReceived2: (subcontractors, action) => {
            subcontractors.filterList2 = action.payload;
            subcontractors.reminder = "";
            subcontractors.loading = false;
            subcontractors.addedUser = null;
            subcontractors.addNewId = 0;
            requestSucceeded(subcontractors.requests, "filter2");
        },
        receivedSubcontractorById: (subcontractors, action) => {
            subcontractors.subByIdList = action.payload;
            requestSucceeded(subcontractors.requests, "byId");
        },
        filterSubcontractorsClear: (subcontractors, action) => {
            subcontractors.filterList = [];
            subcontractors.reminder = "";
            subcontractors.loading = false;
            subcontractors.addedUser = null;
            subcontractors.addNewId = 0;
        },
        reminderSent: (subcontractors, action) => {
            subcontractors.reminder = action.payload;
        },
        subcontractorPerformersReceived: (subcontractors, action) => {
            subcontractors.performers = action.payload;
            subcontractors.loading = false;
            requestSucceeded(subcontractors.requests, "performers");
        },
        subcontractorPerformerAdded: (subcontractors, action) => {
            subcontractors.loading = true;
        },
        validatedDuplicateData: (subcontractors, action) => {
            subcontractors.validateDuplicateData = action.payload;
        },
        checkedSubEmail: (subcontractors, action) => {
            subcontractors.checkSubEmail = action.payload;
            requestSucceeded(subcontractors.requests, "checkEmail");
        },
        checkedSubUsrEmail: (subcontractors, action) => {
            subcontractors.checkSubUsrEmail = action.payload;
            requestSucceeded(subcontractors.requests, "checkUserEmail");
        },
        checkedSubUsrMobile: (subcontractors, action) => {
            subcontractors.checkSubUsrMobile = action.payload;
            requestSucceeded(subcontractors.requests, "checkUserMobile");
        },
        subcontractorBprmFormReceived: (subcontractors, action) => {
            subcontractors.subcontractorBprmForm = action.payload;
        },
        subcontractorBprmFormReset: (subcontractors, action) => {
            subcontractors.subcontractorBprmForm = null
        },
        filterAllSubcontractorStatus: (subcontractors, action) => {
            subcontractors.subcontractorfilter = action.payload
        },
        subsCurrentWfTaskReceived: (subcontractors, action) => {
            subcontractors.currentWfTask = action.payload;
        },
        mailSentToSubcontractor: (subcontractors, action) => {
            subcontractors.mailSentStatus = action.payload;
        },
        loadingRequested: (subcontractors) => {
            subcontractors.loading = true;
        },
        loadingFailed: (subcontractors) => {
            subcontractors.loading = false;
        }
    }
});

export const { subcontractorAdded, subcontractorUserRefresh, subcontractorsReceived, subcontractorUserStatus, subcontractorUserid,
    subcontractorRequestStarted, subcontractorRequestFailed,
    filterSubcontractorsReceived, filterSubcontractorsReceived2, filterSubcontractorsClear, reminderSent,
    subcontractorPerformersReceived, subcontractorPerformerAdded,
    subcontractorUserAdded, checkedSubEmail, checkedSubUsrEmail,
    checkedSubUsrMobile, validatedDuplicateData, subcontractorBprmFormReceived,
    subcontractorBprmFormReset, filterAllSubcontractorStatus, subsCurrentWfTaskReceived,
    mailSentToSubcontractor,receivedSubcontractorById, loadingRequested, loadingFailed } = slice.actions;
export default slice.reducer;

export const loadSubcontractors = (pageSize, currentPage, type) => apiCallBegan({
    url: config.SetupUsers.GetPartners + pageSize + "&pageNumber=" + currentPage + "&type=" + type,
    onStart: { type: subcontractorRequestStarted.type, payload: "list" },
    onSuccess: subcontractorsReceived.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "list" } }
});

export const loadSubcontractorsByFilter = (data) => apiCallBegan({
    url: config.GetPartnersByFilter,
    method: "post",
    data: data,
    onStart: { type: subcontractorRequestStarted.type, payload: "filter" },
    onSuccess: filterSubcontractorsReceived.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "filter" } },
    cancelPrevious: true,
    cancelKey: "subcontractors/filter"
});

export const loadSubcontractorsByFilter2 = (data) => apiCallBegan({
    url: config.GetPartnersByFilter,
    method: "post",
    data: data,
    onStart: { type: subcontractorRequestStarted.type, payload: "filter2" },
    onSuccess: filterSubcontractorsReceived2.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "filter2" } },
    cancelPrevious: true,
    cancelKey: "subcontractors/filter2"
});

export const loadSubcontractorById = (data) => apiCallBegan({
    url: config.GetPartnersByFilter,
    method: "post",
    data: data,
    onStart: { type: subcontractorRequestStarted.type, payload: "byId" },
    onSuccess: receivedSubcontractorById.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "byId" } },
    cancelPrevious: true,
    cancelKey: "subcontractors/by-id"
});


export const SendReminder = (id) => apiCallBegan({
    url: config.SendRemainderToApplicant + id,
    onSuccess: reminderSent.type
});

export const loadSubcontractorPerformers = (id, forceRefresh = false) => apiCallBegan({
    url: `${config.SetupUsers.GetPartnerPerformers}${id}`,
    onStart: { type: subcontractorRequestStarted.type, payload: "performers" },
    onSuccess: subcontractorPerformersReceived.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "performers" } },
    cache: true,
    cacheDuration: 60000,
    forceRefresh
});

export const addNewSubcontractor = (data) => apiCallBegan({
    url: config.AddNewPartner,
    method: "post",
    data: data,
    onSuccess: subcontractorAdded.type
})

export const addNewSubcontractorUser = (data) => apiCallBegan({
    url: config.Registration,
    method: "post",
    data: data,
    onSuccess: subcontractorUserAdded.type
});

export const AddSubcontractorPerformer = (data) => apiCallBegan({
    url: config.SetupUsers.AddPartnerPerformer,
    method: "post",
    data: data,
    onSuccess: subcontractorPerformerAdded.type
});

export const sendMailToSubcontrator = (id) => apiCallBegan({
    url: config.SendMailToNewlyAddedPartner + id,
    onSuccess: mailSentToSubcontractor.type
});

export const checkSubcontractorEmail = (email, datatype) => apiCallBegan({
    url: config.CheckExistingPartnerByEmail + email + "&type=" + datatype,
    onStart: { type: subcontractorRequestStarted.type, payload: "checkEmail" },
    onSuccess: checkedSubEmail.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "checkEmail" } },
    cancelPrevious: true,
    cancelKey: "subcontractors/check-email"
});

export const checkSubcontractorUsrEmail = (email, datatype) => apiCallBegan({
    url: config.CheckExistingPerformerByEmail + email + "&type=" + datatype,
    onStart: { type: subcontractorRequestStarted.type, payload: "checkUserEmail" },
    onSuccess: checkedSubUsrEmail.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "checkUserEmail" } },
    cancelPrevious: true,
    cancelKey: "subcontractors/check-user-email"
});

export const checkSubcontractorUsrMobile = (mobile, datatype) => apiCallBegan({
    url: config.CheckExistingPerformerByPhone + mobile + "&type=" + datatype,
    onStart: { type: subcontractorRequestStarted.type, payload: "checkUserMobile" },
    onSuccess: checkedSubUsrMobile.type,
    onError: { type: subcontractorRequestFailed.type, payload: { key: "checkUserMobile" } },
    cancelPrevious: true,
    cancelKey: "subcontractors/check-user-mobile"
});

export const loadSubcontractorBprmForm = (id) => apiCallBegan({
    url: config.GetForm + id,
    onSuccess: subcontractorBprmFormReceived.type
});

export const loadSubcontractorWfTask = (id) => apiCallBegan({
    url: config.GetApplicantCurrentWfTask + id,
    onSuccess: subsCurrentWfTaskReceived.type
});


export const getAllSubcontractors = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.list
);

export const getFilterAllSubcontractors = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.filterList
);

export const getFilterAllSubcontractors2 = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.filterList2
);

export const getSubcontractorById = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.subByIdList
);

export const getReminderStatus = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.reminder
)

export const getAddedSubPerformerStatus = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.loading
)

export const getSubcontractorPerformers = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.performers
);

export const getNewSubcontractorId = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.addNewId
);

export const getNewSubcontractorUser = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.addedUser
);

export const getValidateDuplicateDataStatus = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.validateDuplicateData
);

export const getCheckSubEmailStatus = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.checkSubEmail
);

export const getCheckSubUsrEmailStatus = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.checkSubUsrEmail
);

export const getCheckSubUsrMobileStatus = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.checkSubUsrMobile
);

export const getSubcontractorBprmForm = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.subcontractorBprmForm
);

export const getSubcontractorFilter = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.subcontractorfilter
);

export const getSubsCurrentWfTask = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.currentWfTask
);

export const getSubcontractorRequests = createSelector(
    state => state.entities.subcontractors,
    subcontractors => subcontractors.requests
);
